export default __webpack_public_path__ + "static/media/maintenance.938d28ce.svg";